import { RichText as RichTextComponent } from '@almbrand/richtext';
import classNames from 'classnames';
import { CLARITY_UNMASK_CLASS } from 'constants/clarity';
import { replacePlaceholders } from 'utilities/placeholderReplacer';
import './RichText.scss';

export interface RichTextProps extends WizardComponentBase {
	description: string;
}

export const RichText: React.FC<RichTextProps> = ({ fieldName = '', description }) => {
	return (
		<RichTextComponent
			className={classNames('RichText', CLARITY_UNMASK_CLASS)}
			fieldName={fieldName}
			description={replacePlaceholders(description)}
		/>
	);
};
